import {
  Card,
  Link,
  Text,
  Button,
  Heading,
  CardBody,
  CardFooter,
  CardHeader,
  ButtonGroup,
  TrackScrolledIntoView
} from '@homebotapp/hb-react-component-catalog'
import { selectCurrentCELs, selectCurrentHelocs } from '../../../store/selectors/home/loans'
import { useState } from 'react'
import { addLoan } from '../../../actions/loan'
import useViewport from '../../../hooks/useViewport'
import { useIntl, defineMessages } from 'react-intl'
import { addHomeAnswer } from '../../../actions/home'
import { openLoans } from '../../../actions/homeowner'
import { useDispatch, useSelector } from 'react-redux'
import BotHead from '../../shared/Avatar/BotHeadColored'
import { selectPaidInFull } from '../../../store/selectors/home/answers'
import { HOMEOWNER_DIGEST_NO_LOANS_MODULE } from '../../../constants/tracking/trackingEventLocations/homeownerDigestTrackingEventLocation'
import { MANAGE_LOANS_EMPTY_STATE } from '../../../constants/document_ids'

const MSG = defineMessages({
  helocHead: {
    id: 'NoLoans.heading.onlyHelocs',
    defaultMessage: 'Do we have all of your loans?'
  },
  nothingHead: {
    id: 'NoLoans.heading.nothing',
    defaultMessage: 'Do you have any loans?'
  },
  helocHTML: {
    id: 'NoLoans.description.onlyHelocsHTML',
    defaultMessage:
      "We've searched public records and found a HELOC.{br}Adding your conventional loans if you have them will make Homebot more accurate."
  },
  nothingHTML: {
    id: 'NoLoans.description.nothingHTML',
    defaultMessage:
      "We've searched public records and have come up empty!{br}Adding a couple loan details makes Homebot more accurate."
  },
  addLoan: {
    id: 'NoLoans.button.addLoan',
    defaultMessage: 'Add a loan'
  },
  heloc: {
    id: 'NoLoans.button.onlyHelocs',
    defaultMessage: "I don't have more loans"
  },
  nothing: {
    id: 'NoLoans.button.nothing',
    defaultMessage: "I don't have loans"
  },
  privacy: {
    id: 'NoLoans.button.privacy',
    defaultMessage: 'Read our privacy policy'
  }
})

export const NoLoansModule = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const [hide, setHide] = useState(false)
  const { isMediumOrAbove } = useViewport()
  const paidInFull = useSelector(selectPaidInFull)
  const celCnt = useSelector(selectCurrentCELs)?.length
  const helocCnt = useSelector(selectCurrentHelocs)?.length

  if (celCnt || paidInFull || hide) return null

  return (
    <TrackScrolledIntoView
      tracking={{
        guid: 'osTCwZZy7TM4Q3JchWFvGb',
        ui_context: HOMEOWNER_DIGEST_NO_LOANS_MODULE,
        descriptor: 'Homeowner Digest No Loans Module'
      }}
    >
      <Card
        size='lg'
        data-qa='NoLoansCard'
        id={MANAGE_LOANS_EMPTY_STATE}
        scrollMarginTop='var(--digest-module-scroll-margin-top)'
      >
        <CardHeader textAlign='center'>
          <BotHead quizzical type='error' size='l' />
          <Heading color='warning' fontWeight='light' size='lg'>
            {intl.formatMessage(helocCnt > 0 ? MSG.helocHead : MSG.nothingHead)}
          </Heading>
        </CardHeader>
        <CardBody paddingY={0} textAlign='center'>
          <Text>
            {intl.formatMessage(helocCnt > 0 ? MSG.helocHTML : MSG.nothingHTML, {
              br: <br />
            })}
          </Text>
        </CardBody>
        <CardFooter display='flex' alignItems='center' flexDirection='column' justifyContent='center'>
          <ButtonGroup width='100%' justifyContent='center' orientation={isMediumOrAbove ? 'horizontal' : 'vertical'}>
            <Button
              flex={['1 1 auto', '1 0 50%', null]}
              colorScheme='primary'
              onClick={() => {
                dispatch(openLoans())
                dispatch(addLoan())
              }}
              tracking={{
                guid: '5FJGqZEm19ZW8kxyhsZyx4',
                ui_context: HOMEOWNER_DIGEST_NO_LOANS_MODULE,
                descriptor: MSG.addLoan.defaultMessage
              }}
            >
              {intl.formatMessage(MSG.addLoan)}
            </Button>
            <Button
              flex={['1 1 auto', '1 0 50%', null]}
              onClick={() => {
                dispatch(
                  addHomeAnswer({
                    question: 'isHomePaidInFull',
                    answer: 'true'
                  })
                )
                setHide(true)
              }}
              tracking={{
                guid: '6X8uNemyJC17TySahSsCEc',
                ui_context: HOMEOWNER_DIGEST_NO_LOANS_MODULE,
                descriptor: helocCnt > 0 ? MSG.heloc.defaultMessage : MSG.nothing.defaultMessage
              }}
            >
              {intl.formatMessage(helocCnt > 0 ? MSG.heloc : MSG.nothing)}
            </Button>
          </ButtonGroup>
          <Link
            marginTop={4}
            href='https://homebot.ai/privacy-policy'
            tracking={{
              guid: 'qQeLhtkZroQ72LPF5jyPZX',
              ui_context: HOMEOWNER_DIGEST_NO_LOANS_MODULE,
              descriptor: MSG.privacy.defaultMessage
            }}
          >
            {intl.formatMessage(MSG.privacy)}
          </Link>
        </CardFooter>
      </Card>
    </TrackScrolledIntoView>
  )
}
